import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { cn } from "@/lib/utils";

const EASE = [0.16, 1, 0.3, 1];

export const MaskedLine = ({ children, delay = 0, className }) => {
  const reduce = useReducedMotion();
  return (
    <span className={cn("block overflow-hidden pb-[0.12em] -mb-[0.12em]", className)}>
      <motion.span
        className="block will-change-transform"
        initial={reduce ? false : { y: "115%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export const FadeUp = ({ children, delay = 0, className, y = 36 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

export const ParallaxImage = ({ src, alt, className, imgClassName, arch = false, testId }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-9%", "9%"]);
  return (
    <div
      ref={ref}
      data-testid={testId}
      className={cn("overflow-hidden", arch && "rounded-t-[999px]", className)}
    >
      <motion.img
        src={src}
        alt={alt}
        style={reduce ? undefined : { y }}
        className={cn("h-full w-full scale-[1.22] object-cover", imgClassName)}
      />
    </div>
  );
};
